<template>
	<div class="login-container block">
		<el-tabs v-model="activeName" :stretch="true">
			<el-tab-pane label="账号密码登录" name="first">
				<el-form
					ref="login_form"
					:model="loginInfo"
					:rules="rules"
					:hide-required-asterisk="true"
					@submit.native.prevent="onSubmit"
          autocomplete="off"
				>
					<el-form-item prop="username">
						<el-input
							class="input"
							v-model="loginInfo.username"
							placeholder="请输入账号"
              @input="e => loginInfo.username = e.trim()"
							autofocus
							style="margin-top: 25px;"
							clearable
              autocomplete="off"
						>
							<svg slot="prefix" class="icon" aria-hidden="true">
								<use xlink:href="#icon-chalkboard"></use>
							</svg>
						</el-input>
					</el-form-item>
					<el-form-item prop="password">
						<el-input
							class="input"
							v-model="loginInfo.password"
							:type="showPasswordFlag ? 'password' : 'text'"
							placeholder="请输入密码"
              autocomplete="off"
						>
							<svg slot="prefix" class="icon" aria-hidden="true">
								<use xlink:href="#icon-iconfilllock"></use>
							</svg>
							<img
								slot="suffix"
								:src="require('@/assets/image/eyes.png')"
								width="14px"
								height="16px"
								_opacity="[0.7]"
								_cursor="pointer"
								v-if="!showPasswordFlag"
								@click="showPasswordFlag = true"
							/>
							<img
								slot="suffix"
								:src="require('@/assets/image/eyes-mask.png')"
								width="14px"
								height="16px"
								_opacity="[0.7]"
								_cursor="pointer"
								v-else
								@click="showPasswordFlag = false"
							/>
						</el-input>
					</el-form-item>
          <el-form-item class="right-aligned">
            <el-checkbox v-model="rememberAccountInfo.checked" label="记住账号密码" size="large" />
          </el-form-item>
					<div class="button-box">
						<el-button class="login-btn" type="primary" native-type="submit">立即登录</el-button>
					</div>
				</el-form>
			</el-tab-pane>
			<el-tab-pane label="手机验证码登录" name="secode">
				<el-form
					ref="login_form2"
					:model="loginInfo"
					:rules="rules"
					:hide-required-asterisk="true"
					@submit.native.prevent="PhoneLogin"
				>
					<el-form-item prop="Phone">
						<el-input
							class="input"
							v-model="loginInfo.Phone"
							placeholder="手机号"
							autofocus
							style="margin-top: 25px;"
							clearable
							maxlength="11"
						>
							<i
								slot="prefix"
								class="el-icon-mobile-phone"
								aria-hidden="true"
								style="font-size: 17px; color: #dbdbdb;"
							></i>
						</el-input>
					</el-form-item>
					<el-form-item prop="Code">
						<div _pos="relative">
							<el-input class="input" maxlength="6" v-model="loginInfo.Code" placeholder="请输入验证码">
								<svg slot="prefix" class="icon" aria-hidden="true">
									<use xlink:href="#icon-iconfilllock"></use>
								</svg>
							</el-input>
							<div _pos="absolute" _right="10px" _top="0px">
								<el-button class="exp-blue" type="text" size="medium" v-show="show" @click="GetCode"
									>获取验证码</el-button
								>
								<el-button class="exp-blue" type="text" size="medium" v-show="!show">{{ count }} s后重新获取</el-button>
							</div>
						</div>
					</el-form-item>
					<div class="button-box">
						<el-button class="login-btn" type="primary" native-type="submit">立即登录</el-button>
					</div>
				</el-form>
			</el-tab-pane>
		</el-tabs>
    <CodeTest v-model="code.visible" :confirm="code.event"/>
	</div>
</template>
<script>

import CodeTest from '@/components/CodeTest.vue'
import { loginPreOperation } from './utils'
import { encrypt, decrypt } from '@/utils/compilation'
export default {
	components: { CodeTest }, //微信扫码登录
	data() {
		return {
      rememberAccountInfo: {},
      code: {
        event: null,
        visible: false, // 图形验证码显示
      },
			messageBox: '',
			showPasswordFlag: true,
			id: 'login_container',
			appid: 'wx7587002f10e56cd3',
			scope: 'snsapi_login',
			redirect_uri: 'http://localhost:8080',
			state: '',
			style: '',
			href:
				'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O2hlaWdodDoyMDBweH0NCi5pbXBvd2VyQm94IC5pbmZvIHt3aWR0aDogMjAwcHh9DQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9DQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fQ0KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lfQ0KaWZyYW1lIHtoZWlnaHQ6IDMyMnB4O30NCg==',
			activeName: 'first', //默认显示登录页面
			show: true, //控制验证码的显示
			count: '', //倒计时
			timer: null, //时间
			loginInfo: {
				username: process.env.VUE_APP_USER_NAME,
				password: process.env.VUE_APP_PASSWORD,
				Phone: '',
				Code: ''
			},
			account: [],
			rules: {
				username: [
					{
						required: true,
						message: '请输入账号',
						trigger: 'change'
					}
				],
				password: [{ required: true, message: '请输入密码', trigger: 'change' }],
				Phone: [
					{ required: true, message: '手机号不能为空' },
					{
						type: 'number',
						message: '手机号格式不正确',
						trigger: 'blur',
						transform(value) {
							var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
							if (!phonereg.test(value)) {
								return false
							} else {
								return Number(value)
							}
						}
					}
				],

				Code: [{ required: true, message: '请输入验证码', trigger: 'change' }]
			}
		}
	},
	mounted() {
    this.rememberAccountInfo = JSON.parse(decrypt(localStorage.getItem('rememberAccountInfo') || {}))
    if (this.rememberAccountInfo?.checked) {
      this.loginInfo.username = this.rememberAccountInfo.account
      this.loginInfo.password = this.rememberAccountInfo.password
    }
  },
	methods: {
		onSubmit(_, code = '') {
      this.$store.commit('clearSearchParams')
			this.$refs['login_form'].validate(async valid => {
				if (valid) {
          if (!code) {
            this.code.event = this.onSubmit
            this.code.visible = true
            return
          }
					// 改全局用户状态，然后根据身份跳不同的个人工作台
					await this.$store.dispatch('USER_LOGIN', { ...this.loginInfo, verify_code: code })
          let params = {}
          if (this.rememberAccountInfo?.checked) {
            params = {
              checked: true,
              account: this.loginInfo.username,
              password: this.loginInfo.password
            }
          } else {
            params = {
              checked: false,
              account: '',
              password: ''
            }
          }
          localStorage.setItem('rememberAccountInfo', encrypt(JSON.stringify(params)))
					loginPreOperation(this)
					try {
						this.messageBox?.close()
					} catch (err) {
						console.log(err)
					}
				}
			})
		},
		PhoneLogin(_, code = '') {
      this.$store.commit('clearSearchParams')
			this.$refs['login_form2'].validate(async valid => {
				if (valid) {
          // 图形验证码
          // if (!code) {
          //   this.code.event = this.PhoneLogin
          //   this.code.visible = true
          //   return
          // }
					// 改全局用户状态，然后根据身份跳不同的个人工作台
					await this.$store.dispatch('PHONE_LOGIN', { ...this.loginInfo, from: 'web' })
					loginPreOperation(this)
					try {
						this.messageBox?.close()
					} catch (err) {
						console.log(err)
					}
				}
			})
		},
		GetCode(_, code = '') {
			// if (!/^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/.test(this.loginInfo.Phone)) {
			if (!/^1[3456789]\d{9}$/.test(this.loginInfo.Phone)) {
				this.$message.error('手机号格式不正确')
			} else {
        // 图形验证码
        if (!code) {
          this.code.event = this.GetCode
          this.code.visible = true
          return
        }
				this.$api.account.GetCode({ phone: this.loginInfo.Phone, verify_code: code }).then(cRes => {
					this.$message.success('验证码已发送')
          this.code.visible = false
					if (cRes.code != '') {
						if (!this.timer) {
							const TIME_COUNT = 60 //倒计时的初始值
							this.count = TIME_COUNT
							this.show = false
							this.timer = setInterval(() => {
								if (this.count > 0 && this.count <= TIME_COUNT) {
									this.count--
								} else {
									this.show = true
									clearInterval(this.timer)
									this.timer = null
								}
							}, 1000)
						}
					}
				})
			}
		}
	},
	created() {
		const webtip = window.localStorage.getItem('webtip') ? JSON.parse(window.localStorage.getItem('webtip')) : {}
		if (webtip?.total == 1) {
			this.messageBox = this.$message({
				message: webtip?.message || '未知原因出错~重新登录刷新页面尝试',
				type: webtip?.type || 'error',
				duration: webtip?.duration || 0
			})
			window.localStorage.removeItem('webtip')
		}
	}
}
</script>
<style lang="scss" scoped>
.exp-blue {
	color: #ff5e2a !important; //rgb(255, 255, 255)
}
/deep/.el-tabs__item {
	font-size: 15px;
	font-weight: 600;
}
.block {
	background: #fff;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	border-radius: 8px;
}

.login-container {
	position: relative;
	// height: 400px;
	width: 360px;
	// margin-top: 20px;
	border-radius: 8px;
	.title {
		margin: 0;
		font-size: 24px;
		font-weight: 500;
		color: rgba(48, 49, 51, 1);
		line-height: 33px;
		margin-bottom: 40px;
	}
	.button-box {
		text-align: center;
	}
	.el-form-item {
		margin-bottom: 20px;
		.el-input__prefix {
			display: flex;
			align-items: center;
			color: #cccccc;
		}
		svg {
			font-size: 20px;
			color: #dbdbdb;
		}
	}
}
.select {
	width: 100%;
}
.login-btn {
	width: 100%;
	height: 40px;
	margin-top: 12px;
}
:deep(.el-input__suffix) {
	width: 30px;
}
:deep(.el-input__suffix-inner) {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
}
.right-aligned {
  :deep(.el-form-item__content) {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
